export default __webpack_public_path__ + "static/media/add_circle.c320da37.svg";